<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 项目管理 / 期货列表 / 添加期货</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              币种
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="type" class="boxText">
                <option>cny</option>
                <option>usdt</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              期货类型
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="className" class="boxText">
                <option>涨幅榜</option>
                <option>稳健榜</option>
                <option>人气榜</option>
                <option>短债榜</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              期货名称
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="name" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              期货编码
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="code" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              截止时间
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="buyTime" class="boxText"/>
              yyyy-mm-dd hh:mm:ss
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              预计周期
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="day" class="boxText"/>

            </td>
          </tr>
          <tr>
            <td class="leftTd">
              募集金额
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="num" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              每手价格
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="price" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              最高限制
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="maxBuy" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              预计日利率
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="lilv" class="boxText"/>

            </td>
          </tr>
          <tr>
            <td class="leftTd">
              担保机构
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="company" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              序列号
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="number" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              限购次数
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="maxInvest" class="boxText"/>
            </td>
          </tr>

          <tr>
            <td class="leftTd">
              一级奖励
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="one" class="boxText"/>
              %
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              二级奖励
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="two" class="boxText"/>
              %
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              三级奖励
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="three" class="boxText"/>
              %
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              是否推荐
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="recommend" class="boxText">
                <option>是</option>
                <option>否</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              金币返还
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="gold" class="boxText"/>
              这里填写金币返还比例，1代表1:1返还
            </td>
          </tr>
<!--          <tr>-->
<!--            <td class="leftTd">-->
<!--              浮动分红-->
<!--            </td>-->
<!--            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">-->
<!--              <input v-model="rebateValue" class="boxText"/>-->
<!--              %-->
<!--            </td>-->
<!--          </tr>-->
          <tr>
            <td class="leftTd">
              购买等级
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="buyVip" class="boxText"/>
              特别注意：多个等级使用小写逗号分隔
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              保险比例
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="baoxian" class="boxText"/>
              %
            </td>
          </tr>
<!--          <tr>-->
<!--            <td class="leftTd">-->
<!--              进度-->
<!--            </td>-->
<!--            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">-->
<!--              <input v-model="jindu" class="boxText"/>-->
<!--              %-->
<!--            </td>-->
<!--          </tr>-->
          <tr>
            <td class="leftTd">
              购买人数
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="buyNum" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              联动项目ID
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="bindProject" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              联动金额
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="bindPrice" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              可购买用户
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <textarea v-model="buyUser" class="boxText" style="width: 98%; height: 200px"></textarea>
              <span style="color: red">*为空表示任何用户可以购买，这里输入用户id，格式为"|用户id(code),"</span>
            </td>
          </tr>
<!--          <tr>-->
<!--            <td class="leftTd">-->
<!--              套餐-->
<!--            </td>-->
<!--            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">-->
<!--              <textarea v-model="projectAnticipateDay" class="boxText" style="width: 90%; height: 100px"></textarea><br/>-->
<!--              套餐名称/利率（%）/周期（天）/备注，最后小写逗号分开-->
<!--            </td>-->
<!--          </tr>-->


        </table>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="添加" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "AddFutures",
  data(){
    return{
      className:"涨幅榜",
      type:"cny",
      name:"",
      code:"",
      buyTime:"",
      price:"",
      day:"",
      projectAnticipateDay:"",
      issuingMethod:"",
      industry:"",
      num:"",
      minBuy:"",
      maxBuy:"",
      lilv:"",
      company:"",
      number:"",
      issuePriceEarningsRatio:"",
      issuePriceEarningsRatio1:"",
      netProfitGrowthRate:"",
      hysyl:"",
      maxInvest:"",
      one:"",
      two:"",
      three:"",
      recommend:"是",
      gold:"",
      rebate:"是",
      rebateValue:"",
      state:"待申购",
      buyVip:"",
      baoxian:"",
      jindu:"",
      buyNum:"",
      levelList:[],
      teamLevelList:[],
      bindProject:"",
      bindPrice:"",
      buyUser:""
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    // axiosGet(DO_NET_URL+"api/GetLevel",function (res){
    //   console.log(res.data)
    //   that.levelList=res.data
    //   if(that.levelList.length>0){
    //     that.level=that.levelList[0].levelId
    //   }
    // })
    // axiosGet(DO_NET_URL+"teamLevel/GetLevel",function (res){
    //   console.log(res.data)
    //   that.teamLevelList=res.data
    //   if(that.teamLevelList.length>0){
    //     that.teamLevel=that.teamLevelList[0].levelId
    //   }
    // })
  },
  methods: {
    addAdmin(){
      let that=this
      if(this.name==""){
        toask("请输入期货名称！",6)
        return
      }
      if(this.code==""){
        toask("请输入期货编码！",6)
        return;
      }
      if(this.buyTime==""){
        toask("请输入截止时间！",6)
        return;
      }
      if(this.price==""){
        toask("请输入每手价格！",6)
        return;
      }
      if(this.day==""){
        toask("请输入预计周期！",6)
        return;
      }
      if(this.num==""){
        toask("请输入募集金额！",6)
        return;
      }
      if(this.maxBuy==""){
        toask("请输入最高限制！",6)
        return;
      }
      if(this.maxInvest==""){
        toask("请输入限购次数！",6)
        return;
      }
      if(this.lilv==""){
        toask("请输入预计日利率！",6)
        return;
      }
      if(this.number==""){
        toask("请输入序列号！",6)
        return;
      }
      if(this.one==""){
        toask("请输入一级奖励！",6)
        return;
      }
      if(this.two==""){
        toask("请输入二级奖励！",6)
        return;
      }
      if(this.three==""){
        toask("请输入三级奖励！",6)
        return;
      }
      if(this.gold==""){
        toask("请输入金币返还系数！",6)
        return;
      }
      loading("请求中")
      let param="buyUser="+this.buyUser+"&baoxian=" + this.baoxian + "&buyNum=" + this.buyNum + "&jindu=0&name=" + this.name + "&code=" + this.code + "&type=期货" +
          "&className=" + this.className + "&recommend=" + this.recommend + "&rebate=是&state=集资中&buyTime=" + this.buyTime + "&price=" + this.price
          + "&anticipateDay=" + this.day + "&issuingMethod=&industry=&num=" + this.num + "&minBuy=0" +
          "&maxBuy=" + this.maxBuy + "&stock=0&maxInvest=" + this.maxInvest + "&company=" + this.company + "&gold=" + this.gold + "&number=" + this.number
          + "&rebateValue=0&issuePriceEarningRatio=0&issuePriceEarningsRatio1=0&netProfitGrowthRate=0&hysyl=0&valueAdded=0&" +
          "breakValue=否&lilv=0&anticipateLive=" + this.lilv + "&day=0&buyVip=" + this.buyVip + "&one=" + this.one
          + "&two=" + this.two + "&three=" + this.three+"&currency="+this.type+"&bindProject="+this.bindProject+"&bindPrice="+this.bindPrice
      axiosPost(DO_NET_URL+"project/InsertProject?"+param,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("添加成功",6)
          setTimeout(function (){
            that.$emit("send",'futuresList')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'futuresList')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>